import React from 'react';

import { Loader } from '../../../components/Loader/Loader';
import Button from '../../../components/buttons/Button';
import { packageSizeAsText } from '../OrdersUtil';
import { AddressType, OrderClazz, Region } from '../../../types/orderTypes';
import dayjs from 'dayjs';
import { getHubConfig } from '../../../const/HubConfig';
import ChangeToHubMultipleModal from '../../../components/modals/ChangeToHubMultipleModal';
import { fetchOrder } from '../../../fetch/orderFetch';

function getProgressColor(stage, status) {
  switch (stage) {
    case 0:
      return ['accepted', 'in_delivery', 'delivered'].includes(status)
        ? '#55ab6d'
        : '#cccccc';
    case 1:
      return ['in_delivery', 'delivered'].includes(status)
        ? '#55ab6d'
        : '#cccccc';
    case 2:
      return ['delivered'].includes(status) ? '#55ab6d' : '#cccccc';
    default:
      return '#cccccc';
  }
}

interface State {
  showConfirmModal: boolean;
  order?: OrderClazz;
  loadingOrder: boolean;
}

interface Props {
  orderId: string;
  region: Region;
  bundleId?: string;
  fetchingBundle: boolean;
}

class OrdersMoreInfo extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmModal: false,
      order: null,
      loadingOrder: true,
    };
  }

  componentDidMount() {
    const { orderId } = this.props;
    fetchOrder(orderId).then(order => {
      this.setState({
        order: order,
        loadingOrder: false,
      });
    });
  }

  changeToHub = () => {
    this.setState({ showConfirmModal: true });
  };

  renderMoreInfo = () => {
    const { order } = this.state;
    let createdText = '-';
    const now = dayjs();
    if (order.createdDateDate) {
      if (order.isToday(now)) {
        createdText = dayjs(order.created).format('[Today at] HH:mm');
      } else if (order.isYesterday(now)) {
        createdText = dayjs(order.created).format('[Yesterday at] HH:mm');
      } else {
        createdText = dayjs(order.created).format('DD.MM [at] HH:mm');
      }
    }

    return (
      <div className="pin-codes">
        <div>
          <span className="strong">Pickup pin:</span> {order.pickupPin}
        </div>
        <div className="hidden">
          <span className="strong">Delivery pin:</span> {order.confirmationPin}
        </div>
        <div style={{ height: 10 }} />
        <div>
          <span className="strong">Created:</span> {createdText}
        </div>
        <div>
          <span className="strong">Pickup:</span>{' '}
          {order.pickedAt ? dayjs(order.pickedAt).format('HH:mm') : '-'}
        </div>
        <div>
          <span className="strong">Delivery:</span>{' '}
          {order.deliveredAt ? dayjs(order.deliveredAt).format('HH:mm') : '-'}
        </div>
        <div>
          <span className="strong">Duration:</span> {order.durationInMinutes()}
        </div>
        <div>
          <span className="strong">Notes:</span> {order.noteForCourier || '-'}
        </div>
        <div>
          <span className="strong">Size:</span> {packageSizeAsText(order)}
        </div>
        <div>
          <span className="strong">Packages:</span> {order.packagesNumber}
        </div>
      </div>
    );
  };

  render() {
    const { bundleId, fetchingBundle } = this.props;
    const { order, loadingOrder, showConfirmModal } = this.state;

    if (loadingOrder) {
      return (
        <div>
          <div className="order-list__info-loading">
            <Loader type="spinner" size="large" />
          </div>
        </div>
      );
    }

    const orderViaHub =
      order.warehouseAddress &&
      order.originAddress.addressType === AddressType.HUB;

    return (
      <div>
        <div className="order-list__more-info">
          <div>
            <div className="from-to-box">
              <div className={orderViaHub ? 'from-to-art-3' : 'from-to-art'}>
                <span className="dot-1" />
                {orderViaHub && <span className="dot-2" />}
                <span className="dot-3" />
              </div>
              <div className="from-to">
                <div>
                  <div>{order.senderName}</div>
                  <div>
                    {orderViaHub
                      ? order.warehouseAddress.fullAddressString
                      : order.originAddress.fullAddressString}
                  </div>
                </div>
                {orderViaHub && (
                  <>
                    <div style={{ height: 30 }} />
                    <div>
                      <div>Porterbuddy Hub</div>
                      <div>{order.originAddress.fullAddressString}</div>
                    </div>
                  </>
                )}
                <div style={{ height: 30 }} />
                <div>
                  <div>{order.recipientName}</div>
                  <div>{order.recipientAddress}</div>
                </div>
              </div>
            </div>
            <div style={{ height: 30 }} />
            <Button title="Change to Hub" onClick={() => this.changeToHub()} />
          </div>
          <div>
            <div className="strong">Courier</div>
            <div>{(order && order.courierName) || 'No courier'}</div>
            <div style={{ height: 30 }} />
            <div className="strong">Bundle id</div>
            <div>
              {fetchingBundle && <Loader type="bounce" />}
              {!fetchingBundle && (bundleId || 'N/A')}
            </div>
          </div>
          {this.renderMoreInfo()}
        </div>
        <div style={{ width: '100%', height: 3, display: 'flex' }}>
          <span
            style={{
              flexGrow: 1,
              height: 3,
              backgroundColor: getProgressColor(0, order.status),
            }}
          />
          <span
            style={{
              flexGrow: 1,
              height: 3,
              backgroundColor: getProgressColor(1, order.status),
            }}
          />
          <span
            style={{
              flexGrow: 1,
              height: 3,
              backgroundColor: getProgressColor(2, order.status),
            }}
          />
        </div>
        <div style={{ height: 15, backgroundColor: '#f1f1f1' }} />
        {showConfirmModal && (
          <ChangeToHubMultipleModal
            orderIds={[order.id]}
            hubAddress={getHubConfig(this.props.region).hubAddress}
            onCloseModal={() => this.setState({ showConfirmModal: false })}
            onSelectModal={() => this.setState({ showConfirmModal: false })}
          />
        )}
      </div>
    );
  }
}

export default OrdersMoreInfo;
